import { action, observable } from 'mobx'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import Button from '../../components/Button'
import Card from '../../components/Card'
import Input from '../../components/Input'
import Paragraph from '../../components/Paragraph'
import Row from '../../components/Row'
import request from '../../utils/request'

@observer
class Step2 extends Component {
  @observable error = false
  @observable loading = false
  
  @observable
  fields = {
    code: '',
  }

  @action
  setField = event => {
    this.error = false
    this.fields[event.target.name] = event.target.value
  }

  @action
  setLoading = () => {
    this.loading = true
    this.error = false
  }

  @action
  setError = () => {
    this.loading = false
    this.error = true
  }

  submit = async event => {
    event.preventDefault()
    this.setLoading()
    const res = await request('/api/auth/step2', this.fields)

    if (res.success) {
      window.location = '/dashboard'
    } else {
      this.setError()
    }
  }

  render() {
    const { onCancel } = this.props

    return (
      <Card>
        {this.error && <Card.ErrorMessage />}
        <form onSubmit={this.submit}>          
          <Card.Pad>
            <Paragraph str="prose.authCodeSentPhone" />
            <Input
              disabled={this.loading}
              label="titles.authCode"
              name="code"
              value={this.fields.code}
              onChange={this.setField}
            />
          </Card.Pad>
          <Card.Divider />
          <Card.Pad>
            <Row>
              <Row.Cell>
                <Button
                  color="gray"
                  str="titles.cancel"
                  onClick={onCancel}
                />
              </Row.Cell>
              <Row.Cell>
                <Button
                  color="blue"
                  str="titles.authenticate"
                  type="submit"
                />
              </Row.Cell>
            </Row>
          </Card.Pad>
        </form>
      </Card>
    )
  }
}

export default withRouter(Step2)



// WEBPACK FOOTER //
// ./src/pages/Login/Step2.js